//import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";
import {
  GetProgressStatus,
  getTypeColor,
} from "../shared-functions/notification";
import { ApplyStyle as _s } from "../utils/ApplyStyle";
import {
  GetTitleSafely,
  getHighlightedText,
  truncateWithEllipses,
} from "../utils/helpers";
import TypeBadge from "./TypeBadge";

import TimelapseIcon from "@mui/icons-material/Timelapse";
import clsx from "clsx";
import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";
import { useStore } from "react-redux";
import { Theme247 } from "../styles/Theme247";
import {
  NotificationType,
  NotificationTypeUpdated,
  StatusType,
  getNotificationTooltipAndColor,
} from "../types";
import IconText from "./IconText";
import { Tooltip } from "@mui/material";
import { ReactComponent as SpaceDashboardSvg } from "../assets/SpaceDashBoard.svg";
import { useEffect, useState } from "react";

const NotificationCardItem = (props) => {
  /*
   * States, Constants
   */
  //const i18n = props.i18n;

  // let borderColors = [
  //   "#FF3D00",
  //   "#FFB300",
  //   "#AEAEAE",
  //   "#AEAEAE",
  //   "#AEAEAE",
  //   "#AEAEAE",
  //   "#8E24AA",
  //   "#FFB300",
  // ];

  const store = useStore().getState();
  const notification = props?.data?.notification;
  const cardStyle = generateCardStyle(notification.type);
  const notificationTitle = GetTitleSafely(notification);

  const [onMouseOver, setMouseOver] = useState(false);
  const [customBadgeUI, setCustomBadgeUI] = useState("");

  function generateCardStyle(typecode) {
    if (typecode !== null) {
      let text = NotificationTypeUpdated(Number(typecode), notification);

      return { status: getTypeColor(typecode, "card").class, text: text };
    } else {
      return {
        status: getTypeColor(undefined, "card"),
        text: "Undefined card typecode.",
      };
    }
  }

  /*
   * Styles
   */
  let targetEquipment = store.subscribedEquipments[
    props.data.notification.equipmentnodeid
  ]
    ? store.subscribedEquipments[props.data.notification.equipmentnodeid]
    : "";

  let targetEquipmentPool = undefined;

  Object.keys(store.subscribedEquipmentpools).map((key) => {
    if (store.subscribedEquipmentpools[key].hasequipment) {
      store.subscribedEquipmentpools[key].hasequipment.map((equipment) => {
        if (
          equipment.equipment.nodeid === props.data.notification.equipmentnodeid
        ) {
          targetEquipmentPool = store.subscribedEquipmentpools[key].name;
        }
      });
    }
  });

  let targetArea = undefined;

  Object.keys(store.subscribedAreas).map((key) => {
    if (store.subscribedAreas[key].hasequipment) {
      store.subscribedAreas[key].hasequipment.map((equipment) => {
        if (
          equipment.equipment.nodeid === props.data.notification.equipmentnodeid
        ) {
          targetArea = store.subscribedAreas[key].name;
        }
      });
    }
  });

  let notiTitle = notificationTitle;

  if (notification.hasmaintenancetask) {
    let taskid =
      notification.hasmaintenancetask[0].maintenancetask.maintenancetaskid ==
        null ||
      notification.hasmaintenancetask[0].maintenancetask.maintenancetaskid ==
        undefined
        ? ""
        : notification.hasmaintenancetask[0].maintenancetask.maintenancetaskid;
    notiTitle = taskid + " " + notificationTitle;
  }

  const handleMouseEnter = () => {
    setMouseOver(true);
  };

  const handleMouseLeave = () => {
    setMouseOver(false);
  };

  // handeling for AufgabePlanung Custom UI on Hover Notification Type Badge
  useEffect(() => {
    setCustomBadgeUI(
      onMouseOver && props.onHoverUI ? (
       props.onHoverUI
      ) : (
        <TypeBadge
          typecode={notification.type}
          notification={props?.data?.notification}
          oncard
        />
      )
    );
  }, [onMouseOver]);

  return (
    <Card
      raised={true}
      elevation={Theme247.elevationLow}
      className={clsx("cardItem", _s(Theme247.itemcard.wrapper))}
    >
      <CardActionArea className={_s(Theme247.itemcard.actionAreaWrapper)}>
        <div
          className={clsx(
            _s(Theme247.itemcard.cardInner),
            _s(Theme247.itemcard.status[cardStyle.status])
          )}
          style={{
            borderTopColor:
              notification.type === 6
                ? "#039BE5"
                : getNotificationTooltipAndColor(notification?.type)?.color,
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <div className={_s(Theme247.itemcard.cardTextContainer)}>
            <div className={_s(Theme247.itemcard.header)}>
              <Typography
                className={_s(Theme247.itemcard.title)}
                title={notiTitle}
              >
                <Tooltip title={notiTitle}>
                  {getHighlightedText(
                    truncateWithEllipses(notiTitle, 20),
                    props?.keywordValue
                  )}
                </Tooltip>
              </Typography>
              {customBadgeUI}
            </div>
            <span className={_s(Theme247.itemcard.details)}>
              <div className={_s(Theme247.itemcard.iconTextInline)}>
                {props.showEquipment ? (
                  <>
                    <IconText
                      icon={
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4.99964 2.6665C4.99964 3.03469 4.70116 3.33317 4.33297 3.33317C3.96478 3.33317 3.6663 3.03469 3.6663 2.6665C3.6663 2.29831 3.96478 1.99984 4.33297 1.99984C4.70116 1.99984 4.99964 2.29831 4.99964 2.6665ZM4.50097 4.65955C4.55085 4.73455 4.59673 4.81329 4.63818 4.89561C4.92339 5.46204 4.95642 6.12251 4.72915 6.71457L4.71845 6.74245C4.65052 6.91942 4.56114 7.08738 4.45232 7.24259L3.67513 8.35103C3.43724 8.69033 2.96933 8.77252 2.63004 8.53463C2.29075 8.29673 2.20855 7.82883 2.44644 7.48954L3.22363 6.3811C3.26201 6.32635 3.29354 6.2671 3.3175 6.20468L3.3282 6.1768C3.40396 5.97945 3.39295 5.75929 3.29788 5.57048C3.12394 5.22503 2.71591 5.06841 2.3555 5.20873C2.15851 5.28543 2.00302 5.44167 1.92726 5.63903L1.91656 5.6669C1.8926 5.72933 1.87638 5.79445 1.86827 5.86083L1.70414 7.2046C1.6539 7.61592 1.27973 7.90864 0.8684 7.8584C0.457073 7.80816 0.164355 7.43398 0.214596 7.02266L0.378727 5.67889C0.401709 5.49073 0.447681 5.3061 0.515613 5.12913L0.526312 5.10126C0.753585 4.50919 1.22007 4.04047 1.81104 3.81037C2.06806 3.7103 2.33316 3.66057 2.59497 3.65682C2.42824 3.36484 2.33297 3.0268 2.33297 2.6665C2.33297 1.56193 3.2284 0.666504 4.33297 0.666504C5.05436 0.666504 5.68655 1.04844 6.03835 1.62112L10.8937 3.48856C11.1541 3.38819 11.437 3.33317 11.7327 3.33317C13.0214 3.33317 14.066 4.37784 14.066 5.6665C14.066 6.62528 13.4878 7.449 12.661 7.80789L11.5161 11.6665H11.6663C12.4027 11.6665 12.9996 12.2635 12.9996 12.9998C12.9996 13.7362 12.4027 14.3332 11.6663 14.3332H2.33297C1.59659 14.3332 0.999638 13.7362 0.999638 12.9998C0.999638 12.2635 1.59659 11.6665 2.33297 11.6665H5.75251L9.77765 6.94064C9.62226 6.70269 9.50913 6.43464 9.44893 6.14713L5.14863 4.49317C4.94805 4.58287 4.72999 4.6405 4.50097 4.65955ZM12.566 5.6665C12.566 6.12674 12.1929 6.49984 11.7327 6.49984C11.2725 6.49984 10.8994 6.12674 10.8994 5.6665C10.8994 5.20627 11.2725 4.83317 11.7327 4.83317C12.1929 4.83317 12.566 5.20627 12.566 5.6665Z"
                            fill="#9E9E9E"
                            fillOpacity="0.74"
                          />
                        </svg>
                      }
                      text={targetEquipment ? targetEquipment.name : ""}
                    />
                    {/* Show Hours Unresolved for status 0, 1 */}

                    <IconText
                      icon={<SpaceDashboardSvg />}
                      text={
                        targetArea
                          ? targetArea
                          : targetEquipmentPool
                          ? targetEquipmentPool
                          : ""
                      }
                    />
                  </>
                ) : (
                  false
                )}
              </div>

              {props.showNotificationDetails ? (
                <div className={_s(Theme247.itemcard.iconTextInline)}>
                  <IconText
                    icon={<InformationOutlineIcon />}
                    text={StatusType(notification.status)}
                  />
                  {/* Show Hours Unresolved for status 0, 1 */}
                  {notification.status < 2 ? (
                    <IconText
                      icon={<TimelapseIcon />}
                      text={GetProgressStatus(notification)}
                    />
                  ) : (
                    false
                  )}
                </div>
              ) : (
                false
              )}
            </span>
          </div>
        </div>
      </CardActionArea>
    </Card>
  );
};

NotificationCardItem.defaultProps = {
  showNotificationDetails: true,
  showEquipment: false,
  data: {},
};

//export default connect(({i18n}) => ({i18n}), {})(NotificationCardItem);
export default NotificationCardItem;
